import imgCapabilities from "../../imagens/cardsHomePage/cardCapabilities.png"
import imgGlobalLocations from "../../imagens/cardsHomePage/GlobalLocations.png"
import imgContactUs from "../../imagens/cardsHomePage/imgContactUs.png"
import imgCertificates from "../../imagens/cardsHomePage/imgCertificates.png"
import "./cards.css"
import { Link } from "react-router-dom"


const cardsData = [
    {
        link: "/Capabilities",
        img: imgCapabilities,
        alt: "Capabilities"
    },
    {
        link: "/GlobalLocations",
        img: imgGlobalLocations,
        alt: "Global Locations"
    },
    {
        link: "/ContactUs",
        img: imgContactUs,
        alt: "Contact Us"
    },
    {
        link: "/Certificates",
        img: imgCertificates,
        alt: "Certificates"
    }
];

function Card() {
    return (
        <div className="container-fluid pt-3">
            <div className="d-flex flex-wrap justify-content-around mb-3">
                {cardsData.map((card, index) => (
                    <div key={index} className="d-flex justify-content-center mb-2 mx-2">
                        <Link to={card.link}>
                            <img src={card.img} className="rounded img-fluid custom-img" alt={card.alt} />
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Card